
<script>


import { Doughnut } from 'vue-chartjs'
import randomColor from './randomColor'
export default {
  extends: Doughnut,
  props: {
    chartdata: {
      type: Array,
      default: []
    },
    chartlabels: {
      type: Array,
      default: []
    }
  },

  methods: {

      getData(){
          return {
    datasets: [{
      data: this.chartdata,
      backgroundColor: [
        randomColor(1),
        randomColor(.5),
        randomColor(1),
        randomColor(.5),
        randomColor(1),
      ],
      label: 'Top 5 Regions'
    }],
    labels: this.chartlabels
  }

      },

      getOptions(){

          return  {
    responsive: true,
    legend: {
      position: 'right',
      display:false
    },
    
    title: {
      display: false,
      text: 'Chart.js Doughnut Chart'
    },
    animation: {
      animateScale: true,
      animateRotate: true
    },
      tooltips: {
      callbacks: {
        label: function(tooltipItem, data) {
        
            var dataset = data.datasets[tooltipItem.datasetIndex];
          var total = dataset.data.reduce(function(previousValue, currentValue, currentIndex, array) {
            return previousValue + currentValue;
          });
          
          var currentValue = dataset.data[tooltipItem.index];
          var currentLabel = data.labels[tooltipItem.index];
          var percentage = Math.floor(((currentValue/total) * 100)+0.5);  
          
        
          return currentLabel + ", " + percentage + "%"  ;
        }
      }
    }
  }
          
      }

  },
  mounted () {
    this.renderChart(this.getData(), this.getOptions())
  }
}
</script>